<template>
    <v-flex class="awards" v-if="ypoAwardsInformation.length>0">
        <v-flex tag="h2">{{memberProfileConstants.YPO_AWARDS}}
            <v-flex tag="em" data-qe-id="ypoAwards_seeAll" v-if="seeAllAwards" @click="seeAll">{{memberProfileConstants.SEE_ALL}}</v-flex>
            <v-flex tag="em" data-qe-id="ypoAwards_seeLess" v-if="enabled" @click="seeAll">{{memberProfileConstants.SEE_LESS}}</v-flex>
        </v-flex>
        <status-overlay :action="loadGetYPOAwardsAction" content-height="200px">
        </status-overlay>
        <v-layout row wrap>
            <v-flex xs12 sm6 v-for="(award,index) in awardsDetails" :key="index">
                <v-flex class="awards__row">
                    <i class="fas fa-shield-alt"></i>
                    <v-flex tag="strong">{{award.achievementName}}</v-flex>
                    <v-flex tag="small">{{award.ypoAwardYear}}</v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { memberProfileConstants } from "./memberProfile.constants.js";
import StatusOverlay from '../StatusOverlay/StatusOverlay';

export default {
    name: "YPOAwards",
    data: () => ({
        memberProfileConstants,
        enabled: false,
    }),
    components: {
        StatusOverlay,
    },
    props: {
        memberId: {
            type: String,
            required: true,
        },
    },
    created() {
      if(this.memberId)
          this.getYPOAwards(this.memberId);
    },
    methods: {
        ...mapActions({
            getYPOAwards: `memberProfile/${storeAction.getYPOAwards}`,
        }),
        seeAll() {
            this.enabled = !this.enabled;
        },
    },
    computed: {
        ...mapGetters({
            ypoAwardsInformation: `memberProfile/${storeGetters.ypoAwardsInformation}`,
        }),
        ...mapState("actionState", ["actions"]),
        seeAllAwards() {
            return this.ypoAwardsInformation.length > 4 && !this.enabled;
        },
        loadGetYPOAwardsAction() {
            return this.actions[storeAction.getYPOAwards];
        },
        awardsDetails() {
            return this.enabled ? this.ypoAwardsInformation : this.ypoAwardsInformation.slice(0, 4);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';

.awards {
    border-bottom: 1px solid $ypo-open-blue-gray;
    margin-top: 20px;
    position: relative;
    padding: 0 20px 20px 20px;

    &__row {
        position: relative;
        color: $ypo-dark-gray;
        font-size: 12px;
        line-height: 20px;
        padding-left: 60px;
        margin-bottom: 30px;

        i {
            position: absolute;
            font-size: 30px;
            left: 0;
            top: 0;
        }

        strong {
            color: $ypo-gray-text;
            display: block;
            font-size: 14px;
        }

        small {
            font-size: 12px;
        }
    }

    .overlay {
        top: 35px;
    }
}
h2 {
    color: $ypo_blue;
    font-family: "Raleway", sans-serif;
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 20px;
    line-height: 26px;

    em {
        color: $ypo-cta;
        font-family: "Noto Sans", sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-style: normal;
        margin-left: 10px;
        cursor: pointer;
    }
}
</style>
